import React, { cloneElement, useContext, useEffect, useState } from 'react';

import clsx from 'clsx';

import { useMediaQuery, Box } from '@material-ui/core';
import { useTheme } from '@material-ui/styles';

import LayoutContext from '../../../contexts/LayoutContext/LayoutContext';
import useStyles from './MainContainer.style';
import { makeStyles } from '@material-ui/core';
import { HEADER_TYPE } from '../../../theme/ThemeOptions';
import useViewportWidth from '../../../../myHooks/useViewportWidth';

const MainContainer = ({ header, sidebar, footer, children, className, ...rest }) => {
  const {
    headerType,
    footerType,
    sidebarType,
    isSidebarOpen,
    isSidebarFixed,
    miniSidebarWidth,
    sidebarWidth,
    actionSidebarWidth,
    drawerBreakPoint,
  } = useContext(LayoutContext);

  const theme = useTheme();
  const isDrawer = useMediaQuery(theme.breakpoints.down(drawerBreakPoint));

  const [headerClasses, setHeaderClasses] = useState('');
  const [footerClasses, setFooterClasses] = useState('');
  const [sidebarClasses, setSidebarClasses] = useState('');
  let width = useViewportWidth();
  const widthBreakpoint = 768;
  const isScreenWide = width > widthBreakpoint;

  const classes = useStyles({
    miniSidebarWidth,
    sidebarWidth,
    actionSidebarWidth,
    drawerBreakPoint,
  });

  useEffect(() => {
    if (!header) setHeaderClasses('');
    else if (headerType === HEADER_TYPE.FIXED) setHeaderClasses('Cmt-fixedHeaderLayout');
    else setHeaderClasses('');
  }, [header, headerType]);

  useEffect(() => {
    if (!footer) setFooterClasses('');
    else if (footerType === 'fixed') setFooterClasses('Cmt-FixedFooterLayout');
    else setFooterClasses('');
  }, [footer, footerType]);

  useEffect(() => {
    const newClasses = [];
    if (!sidebar) newClasses.push('');
    else if (sidebarType === 'drawer' || isDrawer) newClasses.push('Cmt-drawerLayout');
    else if (sidebarType === 'mini') newClasses.push(isSidebarOpen ? 'Cmt-fullMiniLayout' : 'Cmt-miniLayout');

    if (isSidebarFixed) newClasses.push('Cmt-sidebar-fixed');

    setSidebarClasses(clsx(newClasses));
  }, [sidebarType, isSidebarOpen, isDrawer, isSidebarFixed, sidebar]);

  return (
    <Box className={clsx(classes.appRoot, headerClasses, sidebarClasses, footerClasses, className)} {...rest}>
      <div className={classes.appInnerRoot}>
        <div className={classes.appMainContainer}>
          {sidebar}
          <div
            className={clsx(classes.appMain, {
              [classes.horizontalScreen]: isScreenWide,
              [classes.verticalScreen]: !isScreenWide,
            })}>
            {header && cloneElement(header, { type: headerType })}
            {children}
            {footer && cloneElement(footer, { type: footerType })}
          </div>
        </div>
      </div>
    </Box>
  );
};

export default MainContainer;
